module.exports = __webpack_public_path__ + "static/media/content.c3b7b31f.png";